import styled from 'styled-components';

export const LoaderBackdrop = styled.div`
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 9999;
`;

export const LoaderCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    min-width: 22rem;
    max-width: 32rem;
    padding: 3rem 4rem;
    background-color: #ffffff;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.2);
    text-align: center;

    svg {
        width: 3rem;
        height: 3rem;
    }
`;

export const LoaderMessage = styled.div`
    font-size: ${({ theme }) => theme.tokens?.SemTypographyLabelLg?.fontSize || '1.125rem'};
    line-height: 1.4;
    color: #16171a;
`;
